import { render, staticRenderFns } from "./EvaluationServicesTab.vue?vue&type=template&id=abe84fec&scoped=true"
import script from "./EvaluationServicesTab.vue?vue&type=script&lang=js"
export * from "./EvaluationServicesTab.vue?vue&type=script&lang=js"
import style0 from "./EvaluationServicesTab.vue?vue&type=style&index=0&id=abe84fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe84fec",
  null
  
)

export default component.exports